export enum HtmlElement {
  DIV = 'div',
  FORM = 'form',
}
